import { render, staticRenderFns } from "./archivemodify.vue?vue&type=template&id=a7dfa960"
import script from "./archivemodify.vue?vue&type=script&lang=js"
export * from "./archivemodify.vue?vue&type=script&lang=js"
import style0 from "./archivemodify.vue?vue&type=style&index=0&id=a7dfa960&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports